export const formatCurrency = (value: string) => {
  const usdFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return usdFormat.format(Number(value));
};
